import React from "react";
import MainStyle from "../../../../MainStyle";
import {Paragraph, Title} from "../TermsText";

const WarrantySection = () => {
  return (
    <>
      <Title>{"6. Manufacturer's Warranty and Disclaimers."}</Title>

      <Paragraph variant="primary">
        {"ALL PRODUCTS AND SERVICES OFFERED ON THIS SITE ARE PROVIDED “AS IS” WITHOUT ANY WARRANTY WHATSOEVER, INCLUDING, WITHOUT LIMITATION, ANY (A) WARRANTY OF MERCHANTABILITY; (B) WARRANTY OF FITNESS FOR A PARTICULAR PURPOSE; OR (C) WARRANTY AGAINST INFRINGEMENT OF INTELLECTUAL PROPERTY RIGHTS OF A THIRD PARTY; WHETHER EXPRESS OR IMPLIED BY LAW, COURSE OF DEALING, COURSE OF PERFORMANCE, USAGE OF TRADE, OR OTHERWISE."}
      </Paragraph>

      <Paragraph variant="primary">
        {"SOME JURISDICTIONS LIMIT OR DO NOT ALLOW THE DISCLAIMER OF IMPLIED OR OTHER WARRANTIES SO THE ABOVE DISCLAIMER MAY NOT APPLY TO YOU."}
      </Paragraph>

      <Paragraph variant="primary">
        {"YOU AFFIRM THAT WE SHALL NOT BE LIABLE, UNDER ANY CIRCUMSTANCES, FOR ANY BREACH OF WARRANTY CLAIMS OR FOR ANY DAMAGES ARISING OUT OF THE MANUFACTURER'S FAILURE TO HONOR ITS WARRANTY OBLIGATIONS TO YOU."}
      </Paragraph>

      <Paragraph variant="primary" extraStyle={MainStyle.t_t_u}>
        {"By accessing and using the Company’s Services, regardless of through which Platform, you acknowledge and agree that the owner and/or operator of any venue or facility containing or operating physical facilities or equipment used by you in connection with your use of the Services and/or Platform (each a “Facility Owner Operator”) is not liable for any funds in your Account, any payment due to you by the Company and/or any other loss incurred by you in connection with your access to, and use of the Services through any Platform; and in furtherance of the foregoing, you agree and acknowledge that each such Facility Owner Operator and its respective affiliates are for all purposes hereby included in the definition of Released Parties (as defined in Section 4 below and as used in these Terms.)"}
      </Paragraph>
    </>
  );
};

export default React.memo(WarrantySection);
